import React from 'react';
export default ({ src }) => <img src={src} alt="" />;
